<template>
  <div>

  </div>
</template>

<script>
import useValidation from "@/client/extensions/composition/useValidation";
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from 'vuex'
export default {
  setup() {
    let { getFieldValidation, getValidationsByConfig } = useValidation({});
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations({}, useStore());

    return { getFieldValidation, getValidationsByConfig, asyncOps };
  },
  data: function () {
    return {}
  },
  methods: {
    registerToNewsletter(email) {
      this.performWithUi(async () => {
        let leadResult = await this.asyncOps.asyncCall(
          "agaloola/lead/newsletter",
          { email },
          { method: "post" }
        );

        return !leadResult.hasError;
      });
    },
    startNewsletterRegistration(modalErrorText = false) {
      let field = {
        name: "email",
        type: "email",
        icon: "mail",
        label: "ag.newsletterLead.emailFieldLabel",
        legend: "ag.newsletterLead.emailFieldLegend",
        legendIcon: "info",
        validation: {
          required: {},
          email: {},
        },
      };
      let validation = this.getValidationsByConfig(field.validation, true);

      let hasModalErrorText = modalErrorText && typeof modalErrorText === "string";
      let finalModalText = hasModalErrorText
        ? modalErrorText
        : "ag.newsletterLead.modalContent";

      this.$s.ui.modal
      .prompt(finalModalText, "ag.newsletterLead.modalTitle", {
        field: field,
        contentProps: {
          class: hasModalErrorText ? "c-danger" : "",
        },
      })
      .then((data) => {
        if (!data || !validation.email.$validator(data)) {
          this.$nextTick(() => {
            this.startNewsletterRegistration(
              "ag.newsletterLead.modalContentValidationFailed"
            );
          });
        }

        this.registerToNewsletter(data);
      })
      .catch((e) => {
        //
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>
